// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BioRx7jePc4iRcnknBbF{justify-content:flex-end;height:60px;padding-top:24px;padding-right:20px;display:flex}.iRGT17YsNlMy4vetfLN_{justify-content:center;height:100%;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `BioRx7jePc4iRcnknBbF`,
	"wrapPreview": `iRGT17YsNlMy4vetfLN_`
};
export default ___CSS_LOADER_EXPORT___;
